import { Link } from '../../routes'
import { withI18next } from '../../lib/withI18next'

const UserData = ({ t, name, isAdmin, children }) => (
  <div className="dropdown is-right is-hoverable">
    <div className="dropdown-trigger">
      <button className="button" aria-haspopup="true" aria-controls="dropdown-menu3">
        <span>{t('common:welcome')}, {name}</span>
        <span className="icon is-small">
          <i className="mdi mdi-24px mdi-menu-down" aria-hidden="true" />
        </span>
      </button>
    </div>
    <div className="dropdown-menu" id="dropdown-menu3" role="menu">
      <div className="dropdown-content">
        {children}
        {
          isAdmin &&
          <Link route="/admin">
            <a id="to-account" className="dropdown-item">
              <span className="icon is-small">
                <i className="mdi mdi-cogs" aria-hidden="true" />
              </span>
              <span>{t('common:advanced-features')}</span>
            </a>
          </Link>
        }
        <hr className="dropdown-divider" />
        <Link id="to-logout" route="/logout">
          <a className="dropdown-item">
            <span className="icon is-small">
              <i className="mdi mdi-logout" aria-hidden="true" />
            </span>
            <span>{t('common:navigation_menu-logout')}</span>
          </a>
        </Link>
      </div>
    </div>
  </div>
)

export default withI18next(['common'])(UserData)



// WEBPACK FOOTER //
// ./components/Header/UserData.js